// extracted by mini-css-extract-plugin
export default {"boxFrame":"SmallContextFrame_boxFrame__V2B5A","content":"SmallContextFrame_content__hhIWH"};